module.exports = __webpack_public_path__ + "img/folder.00b50d34.png";